module.exports = __webpack_public_path__ + "static/media/july.33ff713d.jpg";